"use strict";

module.exports = function () {
    return function(input) {
        if (input === 0) return "";
        return input;
    }
}
